// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"caf2ef1e","374":"5af21dbd","526":"0482d343","530":"b3c2098f","540":"02eaadc5","787":"a8e6c4be","815":"d0f5a0c9"}[chunkId] + ".chunk.js";
};